export const PAPER_EXPERT_ADVICES = [
  {
    title: 'Do You Need Place Cards at a Wedding?',
    link: '/expert-advice/do-you-need-place-cards-at-a-wedding',
    img:
      '//images.ctfassets.net/77l22z9el0aa/fga6uklDJq666agoC3P7F/2c296bff50e6277c222e40166a847b46/Hero_Zola__9_.jpg',
  },
  {
    title: 'What do we put on our wedding programs?',
    link: '/expert-advice/wedding-program-dos-and-donts',
    img:
      '//images.ctfassets.net/77l22z9el0aa/6zIqnbyQiG2NwNpfbjJYs3/c28cd6ef7d8b894dff3be051a6c9e0fe/Hero_Zola__12_.jpg',
  },
  {
    title: 'How should we alert to allergens on our menus?',
    link: '/expert-advice/wedding-menu-card-ideas',
    img:
      '//images.ctfassets.net/77l22z9el0aa/4oXAdes3Z0xx0BpFPORbI8/a3cf1cec684be16cb81753c6abd56d7a/Hero_Zola__7_.jpg',
  },
];
